import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";

export default function FloatingHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-colors duration-300 ${isScrolled ? "bg-base-100 shadow-sm" : ""}`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Left: Logo */}
        <div className="flex items-center gap-2 font-bold text-xl">
          <a
            href="#home"
            className="text-3xl font-groteskLogo hover:opacity-80 transition-opacity"
          >
            <h1 className="text-3xl font-groteskLogo">
              PEAK
              <span className="font-bold text-primary -ml-1">^</span>
            </h1>
          </a>
        </div>

        {/* Center: Menu */}
        <nav className="hidden md:flex gap-8 font-grotesk">
          <a
            href="#process"
            className="hover:text-base-content/80 transition-colors"
          >
            how it <span className="font-bold">Works</span>
          </a>
          <a
            href="#science"
            className="hover:text-base-content/80 transition-colors"
          >
            the <span className="font-bold">Sports Science</span>
          </a>
          <a
            href="#coaches"
            className="hover:text-base-content/80 transition-colors"
          >
            for <span className="font-bold">Coaches</span>
          </a>
          <a
            href="#network"
            className="hover:text-base-content/80 transition-colors"
          >
            the <span className="font-bold">Network</span>
          </a>
        </nav>

        {/* Right: Mobile Hamburger Menu / Desktop Login Button */}
        <div className="flex items-center gap-4 relative" ref={dropdownRef}>
          {/* Mobile: Hamburger Menu Button */}
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="md:hidden bg-base-300 text-base-content p-3 rounded-full font-medium font-heading hover:bg-base-300 transition-colors flex items-center justify-center"
            aria-label="Menu"
          >
            <Bars3Icon className="w-6 h-6" />
          </button>

          {/* Desktop: Login Button */}
          <Link
            to="/login"
            className="hidden md:flex bg-base-300 text-base-content text-sm px-8 py-4 rounded-full font-medium font-heading hover:bg-base-300 transition-colors items-center gap-2"
          >
            Login
          </Link>

          {/* Mobile Dropdown Menu */}
          {isDropdownOpen && (
            <div className="absolute top-full right-0 mt-2 w-48 bg-base-100 rounded-xl shadow-lg border border-base-200 py-2 z-50 md:hidden">
              <a
                href="#process"
                className="block px-4 py-3 text-sm font-grotesk text-base-content/80 hover:bg-base-200 transition-colors"
                onClick={() => setIsDropdownOpen(false)}
              >
                how it <span className="font-bold">Works</span>
              </a>
              <a
                href="#science"
                className="block px-4 py-3 text-sm font-grotesk text-base-content/80 hover:bg-base-200 transition-colors"
                onClick={() => setIsDropdownOpen(false)}
              >
                the <span className="font-bold">Sports Science</span>
              </a>
              <a
                href="#coaches"
                className="block px-4 py-3 text-sm font-grotesk text-base-content/80 hover:bg-base-200 transition-colors"
                onClick={() => setIsDropdownOpen(false)}
              >
                for <span className="font-bold">Coaches</span>
              </a>
              <a
                href="#network"
                className="block px-4 py-3 text-sm font-grotesk text-base-content/80 hover:bg-base-200 transition-colors"
                onClick={() => setIsDropdownOpen(false)}
              >
                the <span className="font-bold">Network</span>
              </a>
              <div className="border-t border-base-200 my-2"></div>
              <Link
                to="/login"
                className="block px-4 py-3 text-sm font-grotesk text-base-content/80 hover:bg-base-200 transition-colors"
                onClick={() => setIsDropdownOpen(false)}
              >
                Login
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
